import { Tag } from 'entities/tag'
import { ViewModel } from 'view_models/view_model'

export class TagViewModel extends ViewModel<Tag> {}
